(()=>{if(window.frpProductDetailsInitialized)return;window.frpProductDetailsInitialized=true;const init=()=>{
// Keep draft-product authorization when switching from details to configuration.
const current=new URL(location.href);
if(current.pathname.endsWith('/products_preview')&&current.searchParams.has('preview_key')){
  document.querySelectorAll('.frp-m3-sized [data-detail-buy]').forEach(link=>{
    const target=new URL(link.href,location.origin);
    if(target.origin!==current.origin||!['m3-cowboy','m3-configure'].includes(target.searchParams.get('view')))return;
    const preview=new URL(current.href);
    preview.searchParams.set('view','m3-configure');
    if(target.searchParams.has('variant'))preview.searchParams.set('variant',target.searchParams.get('variant'));
    preview.hash=target.hash;
    link.href=preview.href;
  });
}
document.querySelectorAll('[data-frp-detail]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const apply=id=>{document.querySelectorAll('[data-detail-buy]').forEach(a=>{const url=new URL(a.href,location.origin);url.searchParams.set('variant',id);a.href=url.href;});document.querySelectorAll('[data-frp-detail]').forEach(r=>r.dataset.variant=id);};root.querySelectorAll('[data-detail-color]').forEach(button=>button.addEventListener('click',()=>{const id=button.dataset.variantId;root.querySelectorAll('[data-detail-color]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelector('[data-detail-color-name]').textContent=button.dataset.colorName;document.querySelectorAll('[data-detail-product-image] source').forEach(s=>s.removeAttribute('srcset'));document.querySelectorAll('[data-detail-product-image] img').forEach(img=>{img.removeAttribute('srcset');img.src=button.dataset.image;img.alt=button.dataset.imageAlt;});document.querySelectorAll('[data-detail-price]').forEach(p=>p.textContent=button.dataset.price);const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState(history.state,'',url);apply(id);}));const rail=root.querySelector('.frp-detail__cards'),arrows=[...root.querySelectorAll('[data-detail-slide]')];if(rail&&arrows.length){const updateArrows=()=>arrows.forEach(b=>b.disabled=Number(b.dataset.detailSlide)<0?rail.scrollLeft<2:rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2);arrows.forEach(b=>b.addEventListener('click',()=>rail.scrollBy({left:Number(b.dataset.detailSlide)*(rail.querySelector('article').getBoundingClientRect().width+24),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})));rail.addEventListener('scroll',updateArrows,{passive:true});window.addEventListener('resize',updateArrows);updateArrows();}if(root.matches('[data-size-profile="app"],[data-size-profile="cards_main"],[data-size-profile="footer_cards"]')&&rail){
  const dots=root.querySelector('[data-m3-dots]');
  if(dots&&!dots.closest('.frp-m3-carousel-controls')){
    const controls=document.createElement('div');
    controls.className='frp-m3-carousel-controls';
    const makeButton=(direction,label)=>{
      const button=document.createElement('button');
      button.type='button';button.className='frp-m3-carousel-arrow';
      button.dataset.m3CarouselDirection=String(direction);
      button.setAttribute('aria-label',label);
      if(!rail.id)rail.id=`${root.id}-cards`;
      button.setAttribute('aria-controls',rail.id);
      button.innerHTML='<svg width="40" height="40" viewBox="0 0 50 50" fill="none" aria-hidden="true" focusable="false"><path d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z" fill="#F93116"/><path d="M22.83 35.19L20.62 32.98L28.6 25L20.62 17.02L22.83 14.81L33.02 25L22.83 35.19Z" fill="white"/></svg>';
      button.addEventListener('click',()=>{
        const cards=rail.querySelectorAll(':scope > article');
        const step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:rail.clientWidth;
        const left=Math.max(0,Math.min(rail.scrollLeft+direction*step,rail.scrollWidth-rail.clientWidth));
        rail.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      });
      return button;
    };
    const previous=makeButton(-1,'Previous slide');
    const next=makeButton(1,'Next slide');
    dots.replaceWith(controls);controls.append(previous,dots,next);
    const update=()=>{
      const max=rail.scrollWidth-rail.clientWidth;
      controls.hidden=max<=2;
      previous.disabled=rail.scrollLeft<=2;
      next.disabled=rail.scrollLeft>=max-2;
    };
    rail.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    const observer=typeof ResizeObserver==='function'?new ResizeObserver(update):null;
    observer?.observe(rail);
    root.frpCarouselCleanup=()=>{observer?.disconnect();rail.removeEventListener('scroll',update);window.removeEventListener('resize',update);};
    update();
  }
}
const media=matchMedia('(max-width:749px)'),motion=matchMedia('(prefers-reduced-motion:reduce)'),videos=[...root.querySelectorAll('video')],visible=new WeakSet();
videos.forEach(v=>v.addEventListener('error',()=>{v.hidden=true;}));
const active=v=>{
  const mobile=!!v.closest('.frp-detail-media__mobile');
  const background=!!v.closest('[data-m3-video-autoplay]');
  return mobile===media.matches&&!motion.matches&&!document.hidden&&(!background||visible.has(v));
};
const sync=()=>{videos.forEach(v=>{
  if(!active(v)){v.pause();return;}
  const deferred=[v,...v.querySelectorAll('source')].filter(node=>node.dataset.src);
  if(deferred.length){
    deferred.forEach(node=>{node.src=node.dataset.src;delete node.dataset.src;});
    v.preload='metadata';
    v.load();
  }else if(!v.closest('[data-m3-video-autoplay]')&&v.preload==='none'){
    v.preload='metadata';v.load();
  }
  if(v.closest('[data-detail-media]')?.dataset.autoplay==='true'){
    v.play().then(()=>{if(!active(v))v.pause();}).catch(()=>{});
  }
});};
let observer;
if('IntersectionObserver' in window){
  observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target);});
    sync();
  },{threshold:0.1,rootMargin:'100px 0px'});
  videos.filter(v=>v.closest('[data-m3-video-autoplay]')).forEach(v=>observer.observe(v));
}else{
  videos.filter(v=>v.closest('[data-m3-video-autoplay]')).forEach(v=>visible.add(v));
}
document.addEventListener('visibilitychange',sync);
root.frpMediaCleanup=()=>{
  observer?.disconnect();
  media.removeEventListener('change',sync);
  motion.removeEventListener('change',sync);
  document.removeEventListener('visibilitychange',sync);
  videos.forEach(v=>v.pause());
};
media.addEventListener('change',sync);motion.addEventListener('change',sync);sync();});};init();document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-frp-detail]').forEach(root=>{root.frpMediaCleanup?.();root.frpCarouselCleanup?.();}));})();